import { MixinsOptions } from '@material-ui/core/styles/createMixins';

export const initializeMixins = (config?: MixinsOptions): MixinsOptions => {
  return {
    ...config,
  };
};
